function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7148 11.1021L13.1927 2.58C12.8327 2.22 12.3327 2 11.7827 2H4.78271C3.68271 2 2.78271 2.9 2.78271 4V11C2.78271 11.55 3.00271 12.05 3.37271 12.42L11.8948 20.9421C12.2548 21.3021 12.7548 21.5221 13.3048 21.5221C13.8548 21.5221 14.3548 21.3021 14.7148 20.9321L21.7148 13.9321C22.0848 13.5721 22.3048 13.0721 22.3048 12.5221C22.3048 11.9721 22.0748 11.4621 21.7148 11.1021ZM13.3048 19.5321L4.78271 11V4H11.7827V3.99L20.3048 12.5121L13.3048 19.5321Z",
  fill: "#CBD2D4"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65624 8.37383C8.48467 8.37383 9.15624 7.70226 9.15624 6.87383C9.15624 6.0454 8.48467 5.37383 7.65624 5.37383C6.82782 5.37383 6.15624 6.0454 6.15624 6.87383C6.15624 7.70226 6.82782 8.37383 7.65624 8.37383Z",
  fill: "#CBD2D4"
});
function SvgDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/deals.3fdeb685.svg";
export { ForwardRef as ReactComponent };